import { forwardRef, type HTMLAttributes, useImperativeHandle } from 'react';
import { motion, useAnimation, type Variants } from 'framer-motion';

const pathVariants: Variants = {
  normal: {
    pathLength: 1,
    opacity: 1
  },
  animate: {
    pathLength: [0, 1],
    opacity: [0, 1],
    transition: {
      delay: 0.1,
      duration: 0.26,
      opacity: { delay: 0.1 }
    }
  }
};

const arrowVariants: Variants = {
  normal: { d: 'M10.5 4.5H13.5V7.5', opacity: 1 },
  animate: {
    d: ['M7.5 8.5L10.5 7.5L9.5 10.5', 'M10.5 4.5H13.5V7.5'],
    opacity: [0, 1],
    transition: {
      delay: 0.14,
      duration: 0.35,
      opacity: { delay: 0.1 }
    }
  }
};

export interface CtaIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

interface ChartSplineIconProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
}

export const CtaIcon = forwardRef<CtaIconHandle, ChartSplineIconProps>(
  function CtaIcon(props, ref) {
    const controls = useAnimation();

    useImperativeHandle(ref, () => {
      return {
        startAnimation: () => controls.start('animate'),
        stopAnimation: () => controls.start('normal')
      };
    });

    return (
      <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg">
        <motion.path
          animate={controls}
          d="M2.5 11.5L6.75 7L9 9.5L13 5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={pathVariants}
        />
        <motion.path
          animate={controls}
          d="M10.5 4.5H13.5V7.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          variants={arrowVariants}
        />
      </svg>
    );
  }
);
